import { useState } from '@hookstate/core';
import React from 'react';
import { productKitArray } from '../../components/libs/constants';
import { mediaType } from '../../components/libs/typeInterface';
import ProductReviewContainer from '../../components/ProductDetails/ProductReviewContainer';
import InfluencersSection from '../../components/Shared/InfluencersSection/InfluencersSection';
import LightBox from '../../components/Shared/LightBox';
import BeautySection from '../BeautySection/BeautySection';
import { productData } from '../constants';
import InnerShipping from '../InnerShipping';
import SkinRoutineSection from '../RoutineSection/SkinRoutineSection';
import ClickModal from '../Shared/ClickModal';
import MayLike from './MayLike';
import MiddleSection from './MiddleSection';
import MiddleSectionKit from './MiddleSectionKit';
import ProductTitle from './ProductTitle/ProductTitle';

interface IProductMain {
  productSelected: string;
  productType?: string;
}

const ProductMain = (props: IProductMain) => {
  const { productSelected, productType } = props;
  const [showZoomModal, setShowZoomModal] = React.useState(false);
  const openRedirectModal = useState(false);
  const [initialImage, setInitialImage] = React.useState({} as mediaType);
  let filteredProduct;

  if (productType === 'kit') {
    filteredProduct = productKitArray.filter((item) => item.id.includes(productSelected));
  } else {
    filteredProduct = productData.filter((item) => item.id.includes(productSelected));
  }

  return (
    <>
      {filteredProduct.map((product, index) => {
        return (
          <div key={index} className="w-full">
            <ProductTitle
              setShowZoomModal={setShowZoomModal}
              setInitialImage={setInitialImage}
              media={product.media}
              name={product.name}
              size={product.size}
              shortDesc={product.smallDesc}
              attributes={product.attributes}
              price={product.price}
              mrp={product.mrp}
              link={product.link}
              openRedirectModal={openRedirectModal}
              productType={productType}
            />
            {productType === 'kit' ? (
              <MiddleSectionKit
                productSelected={productSelected}
                tabs={product.tabs}
                inside={product.inside}
              />
            ) : (
              <MiddleSection
                productSelected={productSelected}
                tabs={product.tabs}
                // @ts-ignore
                inside={product.inside}
              />
            )}
            <SkinRoutineSection />
            {productType !== 'kit' && product.reviews.length > 0 && (
              <ProductReviewContainer
                verifiedUser={product.verifiedUser}
                rating={product.rating}
                reviews={product.reviews}
                link={product.link}
              />
            )}
            <InnerShipping />
            <MayLike
              type={productType}
              productData={productData}
              productSelected={productSelected}
              openRedirectModal={openRedirectModal}
            />
            <InfluencersSection isInner />
            <BeautySection isInner />
          </div>
        );
      })}

      {showZoomModal && (
        <LightBox
          onclose={() => {
            setShowZoomModal(false);
          }}
          initalImage={initialImage}
          openModal={showZoomModal}
          data={filteredProduct[0].media}
          name={filteredProduct[0].name}
        />
      )}

      {openRedirectModal.get() && (
        <ClickModal openRedirectModal={openRedirectModal} isOpen={openRedirectModal.get()} />
      )}
    </>
  );
};

export default ProductMain;
